export default __webpack_public_path__ + "static/media/img-proj-omplatform.1e068f95.png";